import { defineRecipe } from '@chakra-ui/react';

export const codeRecipe = defineRecipe({
  className: 'ac-code',
  base: {
    fontFamily: 'acMonospace',
    fontSize: '14px',

    display: 'inline-block',
    padding: '2px 6px',
    margin: '-2px 0px',
    border: '1px solid {colors.grey.light.3}',
    borderRadius: 'md',
    backgroundColor: 'grey.light.1',
  },
});
